import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;
const GetLinkSupplier = () => {
  return axios
    .get(`${URL}/linkSupplier`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const PostLinkSupplier = (recData) => {
  return axios
    .post(`${URL}/linkSupplier`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    })
    .catch((error) => {
      ToastError("Enter all Filelds...!");
    });
};

const DeleteLinkSupplier = (_id) => {
  return axios
    .delete(`${URL}/linkSupplier/${_id}`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        ToastError(res.message);
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const UpdateLinkSupplier = (_id, recData) => {
  return axios
    .put(`${URL}/linkSupplier/${_id}`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const FilterLinkSupplier = (recData) => {
  return axios
    .post(`${URL}/linkSupplierFilter`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export {
  GetLinkSupplier,
  PostLinkSupplier,
  DeleteLinkSupplier,
  UpdateLinkSupplier,
  FilterLinkSupplier,
};
